import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';

import { has } from 'lodash';

import { AuthService } from '../auth.service';
import { AUTH_PATHS } from '../auth';
import { Enums } from '../../../configs/Enums';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';
import { Breadcrumb } from '../../../shared/breadcrumbs/breadcrumbs';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-recovery-access',
  templateUrl: './recovery-access.component.html',
  styleUrls: ['./recovery-access.component.scss'],
  standalone: false,
})
export class RecoveryAccessComponent implements OnInit {
  public AUTH_PATHS = AUTH_PATHS;
  public recoveryError: string | null;
  public recoveryAccessBreadcrumbs: Breadcrumb[] = [{ text: 'Восстановление доступа', url: null }];
  public recoveryForm: UntypedFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl(''),
  });

  constructor(
    private router: Router,
    private authService: AuthService,
    private breadcrumbsService: BreadcrumbsService
  ) {}

  ngOnInit() {
    this.breadcrumbsService.updateBreadcrumbs(this.recoveryAccessBreadcrumbs);
  }

  public onSubmitRecoveryForm(): void {
    this.authService.sendEmail(this.recoveryForm.value).subscribe(
      (response) => {
        this.checkResponse(response['metadata']);
      },
      (error) => {
        this.checkResponse(error.error['metadata']);
      }
    );
  }

  private checkResponse(metadata: any): void {
    if (has(metadata, 'code')) {
      this.checkCode(metadata.code);
    } else {
      this.recoveryError = Enums.errorCodes[Enums.errorCodesMaps['BACKEND_ERROR']];
    }
  }

  private checkCode(code: number): void {
    switch (code) {
      case 100000:
        this.recoveryError = Enums.errorCodes[code];
        return;
      default:
        this.redirectToSendEmailSuccessPage();
        return;
    }
  }

  private redirectToSendEmailSuccessPage(): void {
    this.router.navigate(['/' + AUTH_PATHS.send_email_success], {
      queryParams: { email: this.recoveryForm.value.email },
    });
  }
}
